module.exports = __webpack_public_path__ + "static/img/arachas_behemoth.7206c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/arachas_behemoth.png
// module id = 6zLt
// module chunks = 0